import React from "react";

/* Rising trend — financial statements and figures. */
export const ChartIcon = ({ size = 16, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
       aria-hidden="true" focusable="false" className={className}>
    <path d="M4 19h16" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M6.5 15.5l4-4.5 3 2.5 4.5-5.5"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 8h3.5v3.5"
          stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ChartIcon;
